// extracted by mini-css-extract-plugin
export var parcelRow = "_s5-0";